import { FunctionField, Show, SimpleShowLayout, TextField, type ShowProps } from "react-admin";

export default function MiqaatVenueShow(props: ShowProps) {
  return (
    <Show {...props}>
      <SimpleShowLayout>
        <TextField source="name" label="Name" />
        <FunctionField
          label="Latitude"
          render={(record: { latitude?: number | null }) =>
            record?.latitude == null ? "—" : String(record.latitude)
          }
        />
        <FunctionField
          label="Longitude"
          render={(record: { longitude?: number | null }) =>
            record?.longitude == null ? "—" : String(record.longitude)
          }
        />
        <TextField source="radiusMeters" label="Radius (meters)" />
      </SimpleShowLayout>
    </Show>
  );
}
